import React, {Fragment} from "react";
import PropTypes from "prop-types";

export default function Error(props) {
    return <Fragment>
        <div className="addtextError">
            <div className="addtextErrorRed">Er zijn nog velden niet of onjuist ingevuld.</div>
            <hr/>
            <div className="addtextErrorOrange">
                {props.warnings.map(warn => <p key={warn}>{warn}</p>)}
            </div>
            <div onClick={props.onSkip} id="note3">Doorgaan en advies negeren</div>
            <br/>
        </div>
    </Fragment>;
}

Error.propTypes = {
    warnings: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSkip: PropTypes.func.isRequired
}